import { useState } from "react";
import { Box, Checkbox, Stack } from "@mui/material";
import { useTheme } from "contexts";
import { Custom } from "components";

type Props = {
  id: string;
  label: string;
  src: string;
  checked?: boolean;
  onChange: (id: string, selected: boolean) => void;
};

export const ImageCheckbox = ({
  id,
  label,
  src,
  checked = false,
  onChange,
}: Props) => {
  const { theme } = useTheme();
  const [currentChecked, setCurrentChecked] = useState<boolean>(checked);

  const handleChange = () => {
    setCurrentChecked(() => {
      onChange(id, !currentChecked);
      return !currentChecked;
    });
  };

  return (
    <Box width={1}>
      <Stack spacing={theme.spacing.sm}>
        <Box
          onClick={handleChange}
          sx={{
            cursor: "pointer",
            position: "relative",
            paddingTop: "56.25%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundImage: `url(${src})`,
            borderRadius: theme.border.radius,
            transition: "border 0.3s ease-in-out",
            boxShadow: currentChecked
              ? `0 0 0 2px ${theme.color.accent.color}`
              : "none",
          }}
        >
          {/* Hidden Checkbox */}
          <Checkbox
            checked={currentChecked}
            sx={{
              p: 0,
              right: 5,
              bottom: 5,
              position: "absolute",
              pointerEvents: "none",
              color: theme.color.accent.color,
              "&.Mui-checked": {
                color: theme.color.accent.color,
              },
            }}
          />
        </Box>

        <Custom.Typography
          size={theme.font.xxs}
          sx={{ textAlign: "center", pointerEvents: "none" }}
        >
          {label}
        </Custom.Typography>
      </Stack>
    </Box>
  );
};
